require("./brokerConvenienceTestContainer.scss");

// @vendors
const React = require("react");
const { connect } = require("react-redux");
const PropTypes = require("prop-types");

//@commons
const { OKButton } = require("components/commons/OKButton/OKButton");
const { OKLink } = require('commonsComponents/OKLink');
const OKModal = require('components/commons/OKModal/OKModal');

// @components
const BrokerConvenienceTestCategories = require("../brokerConvenienceTestCategories/brokerConvenienceTestCategories");
const BrokerConvenienceTestQuestionContainer = require("../brokerConvenienceTestQuestionContainer/brokerConvenienceTestQuestionContainer");
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const { OKMessage } = require('commonsComponents/OKMessage');
const BrokerConvenienceTestCoherenceControlModal = require('../brokerConvenienceTestCoherenceControlModal/brokerConvenienceTestCoherenceControlModal')
const BrokerConvenienceTestSustainabilityFinishModal = require('../brokerConvenienceTestSustainabilityFinishModal/brokerConvenienceTestSustainabilityFinishModal')
const BrokerConvenienceTestInitialModal = require('../brokerConvenienceTestInitialModal/brokerConvenienceTestInitialModal');

// @actions
const BrokerConvenienceMiFIDTestActions = require('mifid/actions/brokerConvenienceMiFIDTest');

// @utilites
const { FormattedText, formatText } = require('core/i18n').i18n;
const { taggingEventHandled } = require("utilities/taggingEventHandled");
const { isPrivateEquityTest } = require('mifid/utilities/mifidPrivateEquityHelper');

// @constants
const { PROC_BROKER_CONVENIENCE_TEST } = require("utilities/tagging");
const { PRIVATE_EQUITY_TAGGING_DATA } = require("mifid/constants/constants");

class BrokerConvenienceTestContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sutainabilityModal: false,
            coherenceModalInfo: {
                isOpen: false,
                modalContent: null,
            }
        };
        this.handleTagEvent = this.handleTagEvent.bind(this);
        this.finishTest = this.finishTest.bind(this);
        this.nextStep = this.nextStep.bind(this);
        this.tagAndCancel = this.tagAndCancel.bind(this);
        this.handleTagRejectTest = this.handleTagRejectTest.bind(this);
    }

    componentDidUpdate(prevProps) {
        const { currentStepSubCategory, currentStepCategory, immBrokerConvenienceMiFIDTest } = this.props;
        const testToEvaluateId = immBrokerConvenienceMiFIDTest.getIn(['mifidv2','testToEvaluate', 'tipoTest'])

        if ( prevProps.currentStepSubCategory !== currentStepSubCategory || prevProps.currentStepCategory !== currentStepCategory) {
            const taggingData = PRIVATE_EQUITY_TAGGING_DATA?.[currentStepCategory]?.[currentStepSubCategory];

            if (isPrivateEquityTest(testToEvaluateId) && !!taggingData) {
                const customData = {
                    nombrePagina: taggingData.nombrePagina,
                    tipoProceso: taggingData.tipoProceso,
                    pasoProceso: taggingData.pasoProceso,
                    detalleProceso: taggingData.detalleProceso,
                };
                window &&
                window.utag &&
                window.utag.view &&
                window.utag.view(customData);
            }
        }
    }

    setQuestionShowingId(questionId) {
        this.setState({ quiestionId: questionId });
    }

    handleTagRejectTest() {
        const { handleOmitContinue, immBrokerConvenienceMiFIDTest } = this.props;
        const isV3Test = immBrokerConvenienceMiFIDTest.getIn(['test', 'isV3Test'])
        if(isV3Test) {
            taggingEventHandled(
                PROC_BROKER_CONVENIENCE_TEST,
                "rejectTest",
                "",
                'Experiencia profesional'
            );
        }
        handleOmitContinue();
    }

    buildRejectTestSection(isV3Test) {
        const { handleOmitContinue } = this.props;
        const containerClassName = isV3Test ? "convenience-container__reject-test-v3-container" : "convenience-container__reject-test-container";
        const linkClassName = isV3Test ? 'convenience-container__reject-test-v3-link' : null
        const link = (
            <OKLink modifier="emphasize" onClick={this.handleTagRejectTest} extraClass={linkClassName}>
                <FormattedText value="broker-convenienceMifidRejectTestLink" />
            </OKLink>
        );
        return (
            <div className={containerClassName}>
                <FormattedTextWithComponents
                    value="broker-convenienceMifidRejectTest"
                    injectedComponents={[link]}
                />
            </div>
        );
    }

    handleTagEvent() {
        const {immBrokerConvenienceMiFIDTest} = this.props;
        const firstCategory = immBrokerConvenienceMiFIDTest.getIn(['test', 'schema', 'categories', 0]);
        const isV3Test = immBrokerConvenienceMiFIDTest.getIn(['test', 'isV3Test'])
        const actionEvent = firstCategory.get('id') === 0  && !isV3Test ? 'Motivos del cambio' : 'Experiencia profesional';
        taggingEventHandled(
            PROC_BROKER_CONVENIENCE_TEST,
            "onClickFirsStepDisclaimerLink",
            "",
            actionEvent
        );
        window.open(formatText("broker-convenienceMifidFirstStepDisclaimerURL"), '_blank');
    }

    buildFirstStepInformation() {
        const { immBrokerConvenienceMiFIDTest, flagBasedFeatures, isFirstStep } = this.props;
        const testToEvaluateId = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'testToEvaluate', 'tipoTest']);
        const isV3Test = immBrokerConvenienceMiFIDTest.getIn(['test', 'isV3Test'])
        const rejectTestSection = this.buildRejectTestSection(isV3Test);
        if (isPrivateEquityTest(testToEvaluateId) || !isFirstStep) {
            return null;
        }

        const renderDisclaimer = (classNameContainer, linkClassName, textValue, linkTextValue) => (
            <div className="convenience-container__first-step-disclaimer">
                <OKMessage extraClass={classNameContainer}>
                    <FormattedText className={classNameContainer} value={textValue} />
                    <OKLink
                        target="_blank"
                        onClick={this.handleTagEvent}
                        extraClass={linkClassName}
                    >
                        <FormattedText value={linkTextValue} />
                    </OKLink>
                </OKMessage>
            </div>
        );

        if (isV3Test) {
            return (
                <div>
                    {rejectTestSection}
                    {renderDisclaimer(
                        "convenience-container__first-step-disclaimer-v3",
                        "convenience-container__first-step-disclaimer-link-v3",
                        "broker-convenienceMifidV3FirstStepDisclaimerText",
                        "broker-convenienceMifidV3FirstStepDisclaimerLinkText"
                    )}
                </div>
            );
        } else {
            return (
                <div>
                    {renderDisclaimer(
                        null,
                        null,
                        "broker-convenienceMifidFirstStepDisclaimerText",
                        "broker-convenienceMifidFirstStepDisclaimerLinkText"
                        )}
                    {rejectTestSection}
                </div>
            );
        }
    }

    buildDifferenceModal() {
        const {
            immBrokerConvenienceMiFIDTest,
            hideTestDifferenceModal,
            goToConfirmationStep,
        } = this.props;
        const showModal = immBrokerConvenienceMiFIDTest.get(
            "showDifferenceModal"
        );
        const description = (
            <div>
                <FormattedText value="broker-convenienceMifidDifferenceModal" />
            </div>
        );
        return (
            <OKModal
                description={description}
                footerType="action"
                isOpen={showModal}
                onCloseCallback={hideTestDifferenceModal}
                primaryButtonText="broker-convenienceMifidDifferenceModalCTA"
                onPrimaryButtonClick={goToConfirmationStep}
            />
        );
    }

    closePrivateEquityModal() {
        const { modalContent} = this.state.coherenceModalInfo;
        this.setState({
            coherenceModalInfo: {
                isOpen: false,
                modalContent: modalContent,

            },
        })
    }

    tagAndGoToNextStep() {
        const {
            handleNextStep,
            immBrokerConvenienceMiFIDTest,
            currentStepCategory,
            currentStepSubCategory,
        } = this.props;
        const testToEvaluateId = immBrokerConvenienceMiFIDTest.getIn([
            "mifidv2",
            "testToEvaluate",
            "tipoTest",
        ]);
        const taggingData =
            PRIVATE_EQUITY_TAGGING_DATA?.[currentStepCategory]?.[
                currentStepSubCategory
            ];
        if (isPrivateEquityTest(testToEvaluateId) && !!taggingData) {
            let evenTag;
            const immQuestions = this.getStepQuestion();
            const immRadioButtonQuestion = immQuestions.find(immQuestion => immQuestion.get('inputType') === 'radio');
            if (immRadioButtonQuestion) {
                const immRadioButtonAnswer = immRadioButtonQuestion.get('answer').find(immAnswer => immAnswer.get('selected') === 'S');
                if (immRadioButtonAnswer) {
                    const answerDescription = immRadioButtonAnswer.get('description');
                    evenTag = `respuesta-${answerDescription}`;
                } else {
                    evenTag = 'siguiente';
                }
            } else {
                evenTag = 'siguiente';
            }
            const customData = {
                categoriaEvento: taggingData.tipoProceso,
                accionEvento: taggingData.accionEvento,
                etiquetaEvento: evenTag,
            };
            taggingEventHandled(PROC_BROKER_CONVENIENCE_TEST, 'privateEquityTestNext', customData);
        }
        handleNextStep();
    }

    goToPreviousStep() {
        const {
            handlePreviousStep,
            immBrokerConvenienceMiFIDTest,
            currentStepCategory,
            currentStepSubCategory,
        } = this.props;
        const testToEvaluateId = immBrokerConvenienceMiFIDTest.getIn([
            "mifidv2",
            "testToEvaluate",
            "tipoTest",
        ]);
        const taggingData =
            PRIVATE_EQUITY_TAGGING_DATA?.[currentStepCategory]?.[
                currentStepSubCategory
            ];
        if (isPrivateEquityTest(testToEvaluateId) && !!taggingData) {
            const customData = {
                categoriaEvento: taggingData.tipoProceso,
                accionEvento: taggingData.accionEvento,
            };
            taggingEventHandled(PROC_BROKER_CONVENIENCE_TEST, 'privateEquityTestPrevious', customData);
        }
        handlePreviousStep();
    }


    buildPrivateEquityCoherenceControl() {
        const {isOpen, modalContent} = this.state.coherenceModalInfo;
        const content = <FormattedText value={modalContent} />;
        return (
            <OKModal
                isOpen={isOpen}
                title="broker-convenienceMifidPrivateEquityCoherence_title"
                titleAlignment="center"
                footerType="navigation"
                description={content}
                onCloseCallback={() => this.closePrivateEquityModal()}
                onSecondaryButtonClick={()=>{
                    this.closePrivateEquityModal();
                    this.tagAndGoToNextStep();
                }}
                secondaryButtonText="broker-convenienceMifidPrivateEquityCoherence_continueButton"
                onPrimaryButtonClick={() => this.closePrivateEquityModal()}
                primaryButtonText="broker-convenienceMifidPrivateEquityCoherence_reviewButton"
            />
        );
    }

    buildCoherenceModal() {
        const showModal =
            this.props.immBrokerConvenienceMiFIDTest.get("showCoherenceModal");
        if (showModal) {
            return (
                <BrokerConvenienceTestCoherenceControlModal
                    isLastStep={this.props.isLastStep}
                    categoryName={this.props.currentCategoryName}
                    subCategoryName={this.props.currentSubCategoryName}
                    step={this.props.currentStep}
                />
            );
        }
    }

    nextStep() {
        const {
            immBrokerConvenienceMiFIDTest,
            currentStepSubCategory,
            currentStepCategory,
            immCategories,
        } = this.props;
        const testToEvaluateId = immBrokerConvenienceMiFIDTest.getIn(['mifidv2','testToEvaluate', 'tipoTest'])
        if (isPrivateEquityTest(testToEvaluateId)) {
            const immQuestions = this.getStepQuestion();
            const immInvestmentExpectationsSubCategory = immCategories.getIn([
                1,
                "subCategories",
                0,
            ]);
            const immInvestmentExpectationsQuestion = immInvestmentExpectationsSubCategory.getIn([
                'sections',
                0,
                'questions',
                0,
            ], null);
            const immInvestmentExpectationsAnwser = immInvestmentExpectationsQuestion.get('answer').find(immAnswer => immAnswer.get('selected') === 'S');
            if (currentStepCategory === 1 && currentStepSubCategory === 1) {
                const immEventHorizonQuestion =  immQuestions.get('0');
                const immEventHorizonAnswer = immEventHorizonQuestion.get('answer').find(immAnswer => immAnswer.get('selected') === 'S');
                if (
                    !!immInvestmentExpectationsAnwser &&
                    immInvestmentExpectationsAnwser.get("id") === "33" &&
                    !!immEventHorizonAnswer &&
                    immEventHorizonAnswer.get("id") === "39"
                ) {
                    this.setState({
                        coherenceModalInfo: {
                            isOpen: true,
                            modalContent: "broker-convenienceMifidPrivateEquityCoherence_contentQuestion7",
                        },
                    })
                } else {
                    this.tagAndGoToNextStep();
                }
            } else if (currentStepCategory === 1 && currentStepSubCategory === 2) {
                const immLossLevelQuestion =  immQuestions.get('0');
                const immLossLevelAnswer = immLossLevelQuestion.get('answer').find(immAnswer => immAnswer.get('selected') === 'S');
                if (
                    !!immInvestmentExpectationsAnwser &&
                    immInvestmentExpectationsAnwser.get("id") === "34" &&
                    !!immLossLevelAnswer &&
                    immLossLevelAnswer.get("id") === "44"
                ) {
                    this.setState({
                        coherenceModalInfo: {
                            isOpen: true,
                            modalContent: "broker-convenienceMifidPrivateEquityCoherence_contentQuestion8",
                        },
                    })
                } else {
                    this.tagAndGoToNextStep();
                }
            } else {
                this.tagAndGoToNextStep();
            }

        } else {
            this.tagAndGoToNextStep();
        }
    }

    finishTest() {
        const {
            immCategories,
            immBrokerConvenienceMiFIDTest,
            handleFinishStep,
            currentStepSubCategory,
            currentStepCategory,
        } = this.props;
        const testToEvaluateId = immBrokerConvenienceMiFIDTest.getIn(['mifidv2','testToEvaluate', 'tipoTest'])
        if (isPrivateEquityTest(testToEvaluateId) && currentStepCategory === 3 && currentStepSubCategory === 1) {
            const immSubCategory = immCategories.getIn([
                currentStepCategory,
                "subCategories",
                currentStepSubCategory,
            ]);
            const immSections = immSubCategory.get("sections");
            const immQuestions= immSections.getIn([0, "questions"])

            const immQuestion62 = immQuestions.find(immQuestion => immQuestion.get('id')==='62');
            const immAnswer64 = !!immQuestion62 && immQuestion62.get('answer').find(immAnswer => immAnswer.get('id')==='64');
            const answer64IsSelected = !!immAnswer64 && immAnswer64.get('selected') ==='S'
            if (answer64IsSelected) {
                this.setState(() => {
                    return { sutainabilityModal: true }
                });
            } else {
                const immAnswer65 = !!immQuestion62 && immQuestion62.get('answer').find(immAnswer => immAnswer.get('id')==='65');
                const answer65IsSelected = !!immAnswer65 && immAnswer65.get('selected') ==='S'

                const immQuestion66 = immQuestions.find(immQuestion => immQuestion.get('id')==='66');
                const immAnswer67 = !!immQuestion66 && immQuestion66.get('answer').find(immAnswer => immAnswer.get('id')==='67');
                const answer67IsSelected = !!immAnswer67 && immAnswer67.get('selected') ==='S'

                const immQuestion69 = immQuestions.find(immQuestion => immQuestion.get('id')==='69');
                const immAnswer70 = !!immQuestion69 && immQuestion69.get('answer').find(immAnswer => immAnswer.get('id')==='70');
                const answer70IsSelected = !!immAnswer70 && immAnswer70.get('selected') ==='S'

                const immQuestion73 = immQuestions.find(immQuestion => immQuestion.get('id')==='73');
                const immAnswer74 = !!immQuestion73 && immQuestion73.get('answer').find(immAnswer => immAnswer.get('id')==='74');
                const answer74IsSelected = !!immAnswer74 && immAnswer74.get('selected') ==='S'


                if (answer65IsSelected && (!answer67IsSelected || !answer70IsSelected || !answer74IsSelected)) {
                    this.setState(() => {
                        return { sutainabilityModal: true }
                    });
                } else {
                    handleFinishStep();
                }
            }

        } else {
            handleFinishStep();
        }
    }

    getStepQuestion() {
        const { immCategories, currentStepCategory, currentStepSubCategory } = this.props;
        const immSubCategory = immCategories.getIn([
            currentStepCategory,
            "subCategories",
            currentStepSubCategory,
        ]);
        const immSections = immSubCategory.get("sections");
        const immQuestions = immSections.flatMap(immSection => immSection.get('questions'));
        return immQuestions;
    }

    allowFinishingAlternativeFundTest() {
        const { immBrokerConvenienceMiFIDTest, currentStepCategory, currentStepSubCategory } = this.props ;
        const testToEvaluateId = immBrokerConvenienceMiFIDTest.getIn(['mifidv2','testToEvaluate', 'tipoTest'])

        if (isPrivateEquityTest(testToEvaluateId)) {
            if (currentStepCategory === 3 && currentStepSubCategory === 0) {
                const immBoxesQuestion = this.getStepQuestion().find(immQuestion => immQuestion.get('id') === '58');
                const immBoxesQuestionAnswer = !!immBoxesQuestion && immBoxesQuestion.get('answer').find(immAnswer => immAnswer.get('id') === '59');
                if (immBoxesQuestionAnswer.get('selected') === 'S') {
                    return true;
                }
            } else if(currentStepCategory === 3 && currentStepSubCategory === 1) {
                const immSustainabilityFactorsQuestion = this.getStepQuestion().find(immQuestion => immQuestion.get('id') === '62');
                const immSustainabilityFactorsAnswer = !!immSustainabilityFactorsQuestion
                    && immSustainabilityFactorsQuestion.get('answer').find(immAnswer => immAnswer.get('selected') === 'S');
                if (immSustainabilityFactorsAnswer && (immSustainabilityFactorsAnswer.get('id') === '63' || immSustainabilityFactorsAnswer.get('id') === '64')) {
                    return true;
                }
            }
        }
        return false;
    }

    validAnswer() {
        const immQuestions = this.getStepQuestion();
        return immQuestions.every(immQuestion => !immQuestion.get('invalidAnswer') )
    }

    tagAndCancel() {
        const {
            onClickCancel,
            immBrokerConvenienceMiFIDTest,
            currentStepCategory,
            currentStepSubCategory,
        } = this.props;
        const testToEvaluateId = immBrokerConvenienceMiFIDTest.getIn([
            "mifidv2",
            "testToEvaluate",
            "tipoTest",
        ]);
        const taggingData =
            PRIVATE_EQUITY_TAGGING_DATA?.[currentStepCategory]?.[
                currentStepSubCategory
            ];
        if (isPrivateEquityTest(testToEvaluateId) && !!taggingData) {
            const customData = {
                categoriaEvento: taggingData.tipoProceso,
                accionEvento: taggingData.accionEvento,
            };
            taggingEventHandled(PROC_BROKER_CONVENIENCE_TEST, 'privateEquityTestCancel', customData);
        }
        onClickCancel();
    }

    render() {
        const {
            immCategories,
            currentStepSubCategory,
            currentStepCategory,
            disabledNextButton,
            changeDisabledButton,
            cancelPath,
            flagBasedFeatures,
            immBrokerConvenienceMiFIDTest,
            handleCloseModalInvestmentExperience,
            handleFinishStep
        } = this.props;
        const firstStepInformation = this.buildFirstStepInformation();
        const coherenceModal = this.buildCoherenceModal();
        const differenceModal = this.buildDifferenceModal();
        const privateEquityCoherenceModal = this.buildPrivateEquityCoherenceControl();
        const showInvestmentExperienceModal = immBrokerConvenienceMiFIDTest.get(
            "showInvestmentExperienceModal"
        );

        const allowFinishingTest = this.allowFinishingAlternativeFundTest();
        const disableNext = disabledNextButton || !this.validAnswer();
        const immTestToEvaluate = immBrokerConvenienceMiFIDTest.getIn(['mifidv2','testToEvaluate']);
        const testToEvaluateId = immTestToEvaluate.get('tipoTest');
        const initialTest7Modal = isPrivateEquityTest(testToEvaluateId) && (
            <BrokerConvenienceTestInitialModal
                immBrokerConvenienceMiFIDTest={immBrokerConvenienceMiFIDTest}
                history={this.props.history}
            />
        );
        return (
            <div className="convenience-container">
                <BrokerConvenienceTestSustainabilityFinishModal
                    isOpen={this.state.sutainabilityModal}
                    closeModal={() => this.setState({ sutainabilityModal: false })}
                    handleFinish={handleFinishStep}
                />
                {initialTest7Modal}
                <div className="convenience-container-left">
                    <BrokerConvenienceTestCategories
                        immCategories={immCategories}
                        currentStepSubCategory={currentStepSubCategory}
                        currentStepCategory={currentStepCategory}
                    />

                    <div className="convenience-container__cancel-button">
                        <OKLink onClick={this.tagAndCancel} to={cancelPath}>
                            <FormattedText
                                className="convenience-container__cancel-button-label"
                                value="raSuitabilityTest-cancel"
                            />
                        </OKLink>
                    </div>
                </div>

                <div className="convenience-container-content">
                    <div className="convenience-container__container">
                        <div className="convenience-container-step">
                            <div className="convenience-container-step__content">
                                <div className="convenience-container-step__element">
                                    <BrokerConvenienceTestQuestionContainer
                                        immCategories={immCategories}
                                        currentStep={this.props.currentStep}
                                        currentCategoryName={
                                            this.props.currentCategoryName
                                        }
                                        currentSubCategoryName={
                                            this.props.currentSubCategoryName
                                        }
                                        currentStepCategory={
                                            currentStepCategory
                                        }
                                        currentStepSubCategory={
                                            currentStepSubCategory
                                        }
                                        updateAnswer={this.props.updateAnswer}
                                        immFlagBasedFeatures={flagBasedFeatures}
                                        immBrokerConvenienceMiFIDTest={immBrokerConvenienceMiFIDTest}
                                        showInvestmentExperienceModal={showInvestmentExperienceModal}
                                        handleCloseModalInvestmentExperience={handleCloseModalInvestmentExperience}
                                    />
                                    {firstStepInformation}
                                </div>
                            </div>
                            <div className="convenience-container__buttons">
                                <div className="convenience-container-step__actions-buttons">
                                    {!this.props.isFirstStep ? (
                                        <OKButton
                                            modifier="ghost"
                                            onClick={() => {
                                                this.goToPreviousStep();
                                                changeDisabledButton();
                                            }}
                                        >
                                            <FormattedText value="roboWizard-previous" />
                                        </OKButton>
                                    ) : null}
                                    <div className="convenience-container-step__buttons-right-button">
                                        {this.props.isLastStep || allowFinishingTest ? (
                                            <OKButton
                                                modifier={disableNext ? "ghost" : "secondary"}
                                                onClick={
                                                    this.finishTest
                                                }
                                                disabled={disableNext && !allowFinishingTest}
                                                key={1}
                                            >
                                                <FormattedText value="roboWizard-finish" />
                                            </OKButton>
                                        ) : (
                                            <OKButton
                                                modifier={disableNext ? "ghost" : "secondary"}
                                                onClick={
                                                    this.nextStep
                                                }
                                                disabled={disableNext}
                                                key={1}
                                            >
                                                <FormattedText value="roboWizard-next" />
                                            </OKButton>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {coherenceModal}
                {differenceModal}
                {privateEquityCoherenceModal}
            </div>
        );
    }
}

BrokerConvenienceTestContainer.propTypes = {
    immCategories: PropTypes.object.isRequired,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    isFirstStep: PropTypes.bool.isRequired,
    isLastStep: PropTypes.bool.isRequired,
    isReviewingTest:PropTypes.bool.isRequired,
    currentStepSubCategory: PropTypes.number.isRequired,
    currentStepCategory: PropTypes.number.isRequired,
    handleNextStep: PropTypes.func.isRequired,
    handlePreviousStep: PropTypes.func.isRequired,
    handleOmitContinue: PropTypes.func.isRequired,
    updateAnswer: PropTypes.func.isRequired,
    disabledNextButton: PropTypes.bool.isRequired,
    changeDisabledButton: PropTypes.func.isRequired,
    BrokerConvenienceTestContainer: PropTypes.func.isRequired,
    handleFinishStep: PropTypes.func.isRequired,
    cancelPath: PropTypes.string.isRequired,
    onClickCancel: PropTypes.func.isRequired,
    hideTestDifferenceModal: PropTypes.func.isRequired,
    goToConfirmationStep: PropTypes.func.isRequired,
    getCurrentTestScore: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    flagBasedFeatures: state.flagBasedFeatures,
    immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest,

});

module.exports = connect(
    mapStateToProps, {
        handleCloseModalInvestmentExperience: BrokerConvenienceMiFIDTestActions.handleCloseModalInvestmentExperience,
    }
)(BrokerConvenienceTestContainer);
